import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { SephoraView } from 'types/sephora';
import { SEPHORA_MISSING_ACCOUNT_ERROR } from 'constants/sephora';
import { selectLoyaltyError } from 'selectors/sephora';
import useMartyContext from 'hooks/useMartyContext';
import useSephoraContext from 'hooks/useSephoraContext';
import BeautyInsiderEmailForm from 'components/sephora/BeautyInsiderEmailForm';
import BeautyInsiderVerifyEmailForm from 'components/sephora/BeautyInsiderVerifyEmailForm';
import BeautyInsiderRegisterForm from 'components/sephora/BeautyInsiderRegisterForm';

import css from 'styles/components/sephora/beautyInsiderForm.scss';

const getSephoraFormComponent = (view: SephoraView) =>
  ({
    accountInfo: null,
    linkEmail: <BeautyInsiderEmailForm />,
    verifyEmail: <BeautyInsiderVerifyEmailForm />,
    registerAccount: <BeautyInsiderRegisterForm />
  })[view];

const BeautyInsiderError = () => {
  const { view, setView } = useSephoraContext();
  const loyaltyError = useSelector(selectLoyaltyError);

  if (loyaltyError === SEPHORA_MISSING_ACCOUNT_ERROR) {
    setView('registerAccount');
    return null;
  }

  return loyaltyError && view !== 'verifyEmail' ? <div className={css.errorText}>{loyaltyError}</div> : null;
};

const BeautyInsiderForm = () => {
  const { testId } = useMartyContext();
  const { view } = useSephoraContext();

  const getFormComponent = useCallback(() => getSephoraFormComponent(view), [view]);

  return (
    <div className={css.beautyInsiderForm} data-test-id={testId('beautyInsiderForm')}>
      {getFormComponent()}
      <BeautyInsiderError />
    </div>
  );
};

export default BeautyInsiderForm;
